// -----------------------------
// グローバルな変数はここで定義しておく
// -----------------------------

// -----------------------------
// 関数群
// -----------------------------

// アコーディオンパネル
const setUpAccordion = () => {
  const details = document.querySelectorAll(".js-details");
  const isRunning = "running"; // アニメーション実行中のときに付与する予定のカスタムデータ属性の値
  const isOpend = "is-opened"; // アイコン操作用のクラス名

  details.forEach((element) => {
    const summary = element.querySelector(".js-summary");
    const content = element.querySelector(".js-content");

    summary.addEventListener("click", (event) => {
      event.preventDefault();
      if (element.dataset.animStatus === isRunning) {
        return;
      }
      if (element.open) {
        element.classList.toggle(isOpend);
        const closingAnim = content.animate(
          closingAnimKeyframes(content),
          animTiming
        );

        element.dataset.animStatus = isRunning;
        closingAnim.onfinish = () => {
          element.removeAttribute("open");
          element.dataset.animStatus = "";
        };
      } else {
        element.setAttribute("open", "true");
        element.classList.toggle(isOpend);

        const openingAnim = content.animate(
          openingAnimKeyframes(content),
          animTiming
        );
        element.dataset.animStatus = isRunning;
        openingAnim.onfinish = () => {
          element.dataset.animStatus = "";
        };
      }
    });
  });
};


/* アニメーションの時間とイージング */
const animTiming = {
  duration: 400,
  easing: "ease-out",
};

/*　アコーディオンを閉じるときのキーフレーム　*/
const closingAnimKeyframes = (content) => [
  {
    height: content.offsetHeight + "px",
    opacity: 1,
  },
  {
    height: 0,
    opacity: 0,
  },
];

/* アコーディオンを開くときのキーフレーム */
const openingAnimKeyframes = (content) => [
  {
    height: 0,
    opacity: 0,
  },
  {
    height: content.offsetHeight + "px",
    opacity: 1,
  },
];

var toggleButtons = document.querySelectorAll('.js-toggle');
toggleButtons.forEach(function(button) {
  button.addEventListener('click', function() {
    var targetId = button.dataset.target;
    var content = document.getElementById(targetId);

    if (content.style.height === '0px') {
      var contentContainer = content.querySelector('.accordion-container');
      var contentHeight = contentContainer.offsetHeight;

      content.style.height = contentHeight + 'px';
      content.scrollIntoView({ behavior: 'smooth' });

      button.classList.add('is-opened'); // .is-opened クラスを追加
    } else {
      content.style.height = '0px';
      button.classList.remove('is-opened'); // .is-opened クラスを削除
    }
  });
});

// -----------------------------
// イベント系
// -----------------------------

// DOM読み込まれたら発火
window.addEventListener("DOMContentLoaded", function () {
  setUpAccordion();
  // YouTube IFrame API 読み込みと初期化
  initYouTubePlayer();
  setupPosterPlay();
});

// リサイズ時に発火
window.addEventListener("resize", function () {});

// スクロール時に発火
window.addEventListener("scroll", function () {});

// -----------------------------
// その他
// -----------------------------

//スクロールでアニメーションクラスを追加
// if (document.querySelector(".anm") != null) {
//   const anm = document.querySelectorAll(".anm");
//   const options = {
//     root: null,
//     rootMargin: "-4%",
//     threshold: [0],
//   };
//   const observe = new IntersectionObserver(addAnimation, options);
//   anm.forEach(function (elem, index) {
//     observe.observe(elem);
//   });
//   function addAnimation(entries) {
//     entries.forEach(function (entry) {
//       if (entry.isIntersecting) {
//         entry.target.classList.add("is-show");
//       } else {
//         // entry.target.classList.remove("is-show");
//       }
//     });
//   }
// }


//フローティングバナー
// const intersectionContainer = document.querySelector(".js-inner");
// const intersectionTarget = document.querySelector(".float-banner");
// const infiniteScrollObserver = new IntersectionObserver((entries) => {
//   entries.forEach((entry) => {
//     if (!entry.isIntersecting) {
//       intersectionTarget.classList.remove("is-shown");
//     } else {
//       intersectionTarget.classList.add("is-shown");
//     }
//   });
// });
// infiniteScrollObserver.observe(intersectionContainer);

// -----------------------------
// YouTube IFrame API 関連
// -----------------------------
let ytPlayer;
const ytConfig = {
  elementId: "ytPlayer",
  videoId: "sk9MxI0PLpo",
  width: 640,
  height: 390,
};

const loadYouTubeIframeAPI = () => {
  return new Promise((resolve) => {
    if (window.YT && window.YT.Player) {
      resolve();
      return;
    }
    const tag = document.createElement("script");
    tag.src = "https://www.youtube.com/iframe_api";
    const firstScriptTag = document.getElementsByTagName("script")[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    window.onYouTubeIframeAPIReady = () => resolve();
  });
};

const initYouTubePlayer = async () => {
  const playerEl = document.getElementById(ytConfig.elementId);
  if (!playerEl) return;
  await loadYouTubeIframeAPI();
  ytPlayer = new YT.Player(ytConfig.elementId, {
    height: ytConfig.height,
    width: ytConfig.width,
    videoId: ytConfig.videoId,
    playerVars: {
      rel: 0,
      showinfo : 0,
      controls: 0,
      fs: 0,
      modestbranding: 1,
      disablekb: 1,
      iv_load_policy: 3,
      cc_load_policy: 0,
      enablejsapi: 1,
      playsinline: 1,
      mute: 1,
      loop: 1,
      playlist: "sk9MxI0PLpo",
    },
    events: {
      onReady: (event) => {
        event.target.mute();
      },
      onStateChange: (event) => {
        // 再生開始時にミュートを確実に設定
        if (event.data === YT.PlayerState.PLAYING) {
          event.target.mute();
        }
        if (event.data == YT.PlayerState.ENDED) {
          event.target.playVideo();
        }
      }
    }
  });
  // 初期化後にリサイズして全面フィット
  requestAnimationFrame(resizePlayerToCover);
};

const setupPosterPlay = () => {
  const container = document.querySelector(".youtube_area");
  if (!container) return;
  const playIcon = container.querySelector(".playicon");
  const posterList = container.querySelector(".poster_list");

  const handlePlay = async () => {
    if (posterList) posterList.style.display = "none";
    if (playIcon) playIcon.style.display = "none";
    if (!ytPlayer) {
      await initYouTubePlayer();
      await new Promise((resolve) => setTimeout(resolve, 100));
    }
    try {
      if (ytPlayer && ytPlayer.playVideo) {
        ytPlayer.playVideo();
      }
    } catch (e) {
      console.error("動画再生エラー:", e);
    }
  };

  if (playIcon) playIcon.addEventListener("click", handlePlay);
  // 後方互換: ポスター画像クリックでも再生
  if (posterList) posterList.addEventListener("click", handlePlay);
};

// -----------------------------
// 画面・コンテナ比に応じてiframeを全面カバーさせる
// -----------------------------
const resizePlayerToCover = () => {
  const container = document.querySelector(".youtube_area");
  const iframe = document.getElementById(ytConfig.elementId);
  if (!container || !iframe) return;

  const containerWidth = container.clientWidth;
  const containerHeight = container.clientHeight;
  const containerRatio = containerWidth / containerHeight;

  const videoRatio = 878 / 700; // 元動画意図の比率

  if (containerRatio > videoRatio) {
    // 横長: 幅を基準にして高さを拡大
    iframe.style.width = containerWidth + "px";
    iframe.style.height = containerWidth / videoRatio + "px";
  } else {
    // 縦長: 高さを基準にして幅を拡大
    iframe.style.height = containerHeight + "px";
    iframe.style.width = containerHeight * videoRatio + "px";
  }
};

window.addEventListener("resize", resizePlayerToCover);